import { createFileRoute } from '@tanstack/react-router';

import { ResetPasswordPage } from '@/features/portal/auth/ResetPasswordPage';

export const Route = createFileRoute('/portal/auth/reset-password/$token')({
  component: ResetPasswordRouteComponent,
});

function ResetPasswordRouteComponent() {
  const { token } = Route.useParams();
  return <ResetPasswordPage token={token} />;
}
